import React from 'react';
import { FormattedMessage } from "../../../util/reactIntl";
import { ExternalLink, NamedLink } from '../../../components';
import { Link } from 'react-router-dom';
import config from '../../../config';

import css from './SectionFindTeachersByState.module.css';

const SectionFindTeachersByState = props => {
  const { stateOptions, content, state } = props;

  return <div className={css.sectionHolder}>
    <div className={css.rootTitleHolder}>
      <h2 className={css.rootTitle}>
        {content?.findTitle ?
          content.findTitle :
          <FormattedMessage id="OnlineTeachersForHirePage.teachersByStateTitle" />
        }
      </h2>
    </div>

    <p className={css.rootDescription}>
      {content?.findDescription ?
        content.findDescription :
        <FormattedMessage id="OnlineTeachersForHirePage.teachersByStateSubTitle" />
      }
    </p>

    <ul className={css.stateList}>
      {stateOptions.map((i, index) =>
        <li key={index} className={css.stateItem}>
          <Link className={css.stateLink} to={`/teachers/${i.short}`} >
            {i.label}
          </Link>
        </li>
      )}
    </ul>

  </div>;
};

SectionFindTeachersByState.defaultProps = {
  stateOptions: config.custom.stateOptions,
};

export default SectionFindTeachersByState;
